module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"tag\">Show data from environment:</div> <div class=\"radio-inline\"> <label> <input type=\"radio\" name=\"productionTestToggle\" value=\"production\" ")
    ;  if(locals.mode !== "test") { 
    ; __append(" checked=\"checked\" ")
    ;  } 
    ; __append("> Production </label> </div> <div class=\"radio-inline\"> <label> <input type=\"radio\" name=\"productionTestToggle\" value=\"test\" ")
    ;  if(locals.mode === "test") { 
    ; __append(" checked=\"checked\" ")
    ;  } 
    ; __append("> Test </label> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/api_mode_toggle.ejs
// module id = 824
// module chunks = 1